import { CommonModule, NgClass } from '@angular/common';
import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import type { FooterLink } from '../../footer/footer-link';
import { LinkSection } from './link-section';
import { QueryParamDirective } from '@core-mkt/services/query-param/query-param.directive';

@Component({
  selector: 'dec-link-section',
  templateUrl: './link-section.component.html',
  styleUrls: ['./link-section.component.scss'],
  standalone: true,
  imports: [NgClass, CommonModule, QueryParamDirective],
})
export class LinkSectionComponent implements OnInit {
  @Input() data: LinkSection;
  faCaretRight = faCaretRight;
  faCaretDown = faCaretDown;
  sectionOpen: false;
  sectionIconStyle = { width: '6px', height: '16px', display: 'inline-block' };

  constructor() {}

  get headlineText(): string {
    return this.data.headlineText;
  }

  get headlineLink(): string {
    return this.data.headlineLink;
  }

  get subLinks(): FooterLink[] {
    return this.data.sublinks;
  }

  shouldHaveNofollow(noFollow: boolean): string {
    return noFollow ? 'nofollow' : null;
  }

  ngOnInit() {}
}
